export let PreviewEventType;
(function (PreviewEventType) {
  PreviewEventType["PREVIEW_START"] = "preview_start";
  PreviewEventType["PREVIEW_MESSAGE_DELTA"] = "preview_message_delta";
  PreviewEventType["PREVIEW_END"] = "preview_end";
  PreviewEventType["PREVIEW_EXCEPTION"] = "preview_exception";
})(PreviewEventType || (PreviewEventType = {}));